"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InfuraNode = exports.EthNetwork = exports.BlockscoutNetwork = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _bignumber = require("@ethersproject/bignumber");
var _bytes = require("@ethersproject/bytes");
const addressRegex = /^0x[a-f0-9]{40}$/i;
class InfuraNode {
  constructor(net, projectId) {
    this.net = net;
    this.projectId = projectId;
  }
  getUrl() {
    return `https://${this.net || "mainnet"}.infura.io/v3/${this.projectId}`;
  }
  getWs() {
    return `wss://${this.net || "mainnet"}.infura.io/ws/v3/${this.projectId}`;
  }
}
exports.InfuraNode = InfuraNode;
class EthNetwork {
  constructor(config) {
    (0, _defineProperty2.default)(this, "chainId", void 0);
    (0, _defineProperty2.default)(this, "networkName", void 0);
    (0, _defineProperty2.default)(this, "aliases", void 0);
    (0, _defineProperty2.default)(this, "nodeUrl", void 0);
    (0, _defineProperty2.default)(this, "explorer", void 0);
    (0, _defineProperty2.default)(this, "altNodeUrl", void 0);
    (0, _defineProperty2.default)(this, "coinName", void 0);
    (0, _defineProperty2.default)(this, "symbol", void 0);
    (0, _defineProperty2.default)(this, "description", void 0);
    (0, _defineProperty2.default)(this, "eip1559", void 0);
    (0, _defineProperty2.default)(this, "priorityFee", void 0);
    (0, _defineProperty2.default)(this, "gasPrice", void 0);
    (0, _defineProperty2.default)(this, "ws", void 0);
    (0, _defineProperty2.default)(this, "decimals", 18);
    Object.assign(this, config);
    if (!this.symbol) {
      this.symbol = "ETH";
    }
  }
  get name() {
    return this.networkName;
  }
  get networkId() {
    return this.chainId;
  }
  get alias() {
    return this.aliases[0];
  }
  clone() {
    // @ts-ignore
    return new this.constructor(this);
  }
  getNodeUrl() {
    var _this$nodeUrl;
    if (typeof this.nodeUrl === "string") {
      return this.nodeUrl;
    }
    if ((_this$nodeUrl = this.nodeUrl) !== null && _this$nodeUrl !== void 0 && _this$nodeUrl.getUrl) {
      return this.nodeUrl.getUrl();
    }
    return null;
  }
  getWsUrl() {
    if (this.nodeUrl && typeof this.nodeUrl !== "string") {
      return this.nodeUrl.getWs();
    }
    return this.ws;
  }
  explorerAddress(address) {
    if (this.explorer) {
      if (addressRegex.test(address)) {
        return `${this.explorer}/address/${address}`;
      }
    }
  }
  explorerTx(hash) {
    if (this.explorer) {
      if (/^0x[a-f0-9]{64}$/i.test(hash)) {
        return `${this.explorer}/tx/${hash}`;
      }
    }
  }
  explorerToken(address, wallet) {
    if (this.explorer) {
      if (addressRegex.test(address)) {
        let url = `${this.explorer}/token/${address}`;
        if (addressRegex.test(wallet)) {
          url += `?a=${wallet}`;
        }
        return url;
      }
    }
  }
  hexChainId() {
    return (0, _bytes.hexStripZeros)(_bignumber.BigNumber.from(this.chainId).toHexString());
  }
}
exports.EthNetwork = EthNetwork;
class BlockscoutNetwork extends EthNetwork {
  explorerAddress(address) {
    if (this.explorer) {
      if (addressRegex.test(address)) {
        return `${this.explorer}/address/${address}`;
      }
    }
  }
  explorerTx(hash) {
    if (this.explorer) {
      if (/^0x[a-f0-9]{64}$/i.test(hash)) {
        return `${this.explorer}/tx/${hash}`;
      }
    }
  }
  explorerToken(address, wallet) {
    if (this.explorer) {
      if (addressRegex.test(address)) {
        if (wallet && addressRegex.test(wallet)) {
          return `${this.explorer}/address/${wallet}/tokens/${address}/token-transfers`;
        }
        return `${this.explorer}/tokens/${address}`;
      }
    }
  }
}
exports.BlockscoutNetwork = BlockscoutNetwork;
//# sourceMappingURL=EthNetwork.js.map